var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangelog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 5a3 3 0 01-3-3 1 1 0 00-2 0 3 3 0 01-3 3 1 1 0 000 2 3 3 0 013 3 1 1 0 002 0 3 3 0 013-3 1 1 0 000-2zM10 25a3 3 0 01-3-3 1 1 0 00-2 0 3 3 0 01-3 3 1 1 0 000 2 3 3 0 013 3 1 1 0 002 0 3 3 0 013-3 1 1 0 000-2z",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 31a1 1 0 01-1-1 6.006 6.006 0 00-6-6 1 1 0 010-2 6.006 6.006 0 006-6 1 1 0 012 0 6.006 6.006 0 006 6 1 1 0 010 2 6.006 6.006 0 00-6 6 1 1 0 01-1 1zM9 17a1 1 0 01-1-1 6.006 6.006 0 00-6-6 1 1 0 010-2 6.006 6.006 0 006-6 1 1 0 012 0 6.006 6.006 0 006 6 1 1 0 010 2 6.006 6.006 0 00-6 6 1 1 0 01-1 1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangelog);
export default __webpack_public_path__ + "static/media/changelog.57d54110.svg";
export { ForwardRef as ReactComponent };